/**************************************************************************************************************************************************
*   MODULE NAME     :  SaveSearchTitle
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  04-03-2021
*   DESCRIPTION     :  Modal Component to enter Saved Search Title
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import React, { Component } from "react";
import {checkSavedSearchtitleDuplicate} from "../../actions/searchActions";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import swal from "sweetalert";
import "./Search.css";
import * as messages from  "../../components/common/MessagesPool"
class SaveSearchTitle extends Component {
  constructor(props){
    super(props)
    this.inputRef = React.createRef();
}

  state = {
  titleSavedSearch : "",
  ds:false
  }

  /**update state with input values */
  handleChange = (e) => {
    this.setState({
        [e.target.name]: e.target.value
    });
}

  /**reset modal values */
  resetFn = () => {
    this.setState({
    titleSavedSearch : ""
    })
  }

 saveSearch = async() => {
   this.setState({
     ds:true
   })
    let result =  await this.props.checkSavedSearchtitleDuplicate(this.state.titleSavedSearch);
    if(result && result.data && result.data.result && result.data.result.length && result.data.result.length !== 0){
      swal('',messages.SEARCH_TITLE,"warning")
      this.setState({
        ds:false
      })
    }
    else{
   this.props.saveSearchTitle(this.state.titleSavedSearch.trim())
    }
 }

 componentDidMount(){
  this.inputRef.current.focus();
}
  render() {
    const {
      disableModal,
      saveSearchTitle     
    } = this.props;
  const {
      titleSavedSearch,ds
    } = this.state;

    /**Modal Title */
    const title = "Add Save Search Description";
    /**Save  button disable state */
    const disableSave = ds || titleSavedSearch.trim()==='';   

    return (<>
      <Modal
        className= "titlemodal" 
        centered
        autoFocus
        show={true}
        onHide={() => disableModal("showSaveSearchTitle")}
        backdrop="static"
      >
        <Modal.Header style = {{background: "#115473" ,color: "white"}} closeButton>
          <Modal.Title style = {{color: "white"}}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="instrument-modal-body">
            <Row>
              <Col>
                <Form.Group controlId="titleSavedSearch">
                  <Form.Label>
                    Save Search Description : 
                  </Form.Label>
                  <Form.Control type="text" name="titleSavedSearch"
                    value={titleSavedSearch} onChange={this.handleChange}
                    required 
                    ref = {this.inputRef}/>
                
                </Form.Group>
              </Col>
              </Row>
             </Modal.Body>
        <Modal.Footer>
         <Row> 
           <Col className="text-right mt-3">
              <Button variant="danger" className="mr-2" onClick={() => this.resetFn()}>
                Reset
              </Button>
              <Button variant="primary" className="mr-2" onClick={() => this.saveSearch()} disabled={disableSave}>
                Save
              </Button>
              </Col>
            </Row>
        </Modal.Footer>
      </Modal>
    </>
    )
  }
}
const mapStateToProps = state => {
  return {
  };
};
const mapDispatchToProps = dispatch => {
  return bindActionCreators(
      {
          checkSavedSearchtitleDuplicate
      },
      dispatch
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SaveSearchTitle));
